import { Editor, EditorTools } from "@progress/kendo-react-editor";
import './textarea_app.scss'

import Input from "../sharedComponents/input";
const {
    Bold,
    Italic,
    Underline,
    // Strikethrough,
    // Subscript,
    // Superscript,
    ForeColor,
    // BackColor,
    CleanFormatting,
    AlignLeft,
    AlignCenter,
    AlignRight,
    AlignJustify,
    // Indent,
    // Outdent,
    OrderedList,
    UnorderedList,
    NumberedList,
    BulletedList,
    // Undo,
    // Redo,
    FontSize,
    FontName,
    // FormatBlock,
    // Link,
    // Unlink,
    // InsertImage,
    // ViewHtml,
    InsertTable,
    // InsertFile,
    SelectAll,
    // Print,
    // Pdf,
    // AddRowBefore,
    // AddRowAfter,
    // AddColumnBefore,
    // AddColumnAfter,
    DeleteRow,
    DeleteColumn,
    DeleteTable,
    // MergeCells,
    // SplitCell,

} = EditorTools;

const tools = [
    // [Bold, Italic, Underline, Strikethrough],
    [Bold, Italic, Underline],
    // [Subscript, Superscript],

    ForeColor,
    // BackColor,
    [CleanFormatting],
    [AlignLeft, AlignCenter, AlignRight, AlignJustify],
    // [Indent, Outdent],
    [OrderedList, UnorderedList],
    [NumberedList, BulletedList],
    FontSize,
    FontName,
    // FormatBlock,
    [SelectAll],
    // [Undo, Redo],
    // [Link, Unlink, InsertImage, ViewHtml],
    // [InsertTable, InsertFile],
    [InsertTable],
    // [Pdf, Print],
    // [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
    [DeleteRow, DeleteColumn, DeleteTable],
    // [MergeCells, SplitCell],
];



const RichTextEditor = ({ setDesc, onChange, value }) => {

    const onChangeText = e => {
        setDesc(e.html)
    };


    return (
        <div>
            <div className="k-d-flex k-gap-8">
                <div className="k-flex-grow" style={{ maxWidth: "100%", border: "1px solid lightgray", padding: "10px", marginTop: "10px" }} >
                    <h2 style={{ padding: "10px 0px " }}  >Description</h2>
                    <div style={{ margin: "5px", border: "1px solid lightgray" }}>

                        <Editor


                            onChange={onChange}

                            tools={tools}
                            value={value}

                            contentStyle={{ height: 270 }}




                        />

                    </div>
                </div>

            </div>
        </div>
    );
};

export default RichTextEditor;